import Phaser from 'phaser';
import { CARD_WIDTH, CARD_HEIGHT, COLORS } from '../utils/Constants';

export class DeckDisplay {
  private scene: Phaser.Scene;
  private deckSprite: Phaser.GameObjects.Image | null = null;
  private deckCountText: Phaser.GameObjects.Text | null = null;
  private pozzetto1: Phaser.GameObjects.Image | null = null;
  private pozzetto2: Phaser.GameObjects.Image | null = null;
  private pozzettoLabel1: Phaser.GameObjects.Text | null = null;
  private deckX: number;
  private deckY: number;
  private pozzettoX: number;
  private pozzettoY: number;
  private onDeckClick?: () => void;

  constructor(scene: Phaser.Scene, deckX: number, deckY: number, pozzettoX?: number, pozzettoY?: number) {
    this.scene = scene;
    this.deckX = deckX;
    this.deckY = deckY;
    this.pozzettoX = pozzettoX ?? deckX - CARD_WIDTH - 30;
    this.pozzettoY = pozzettoY ?? deckY;
  }

  setOnDeckClick(callback: () => void): void {
    this.onDeckClick = callback;
  }

  create(): void {
    // Draw pile - stack effect: 3 offset cards
    for (let i = 2; i >= 0; i--) {
      const shadow = this.scene.add.image(this.deckX + i * 2, this.deckY + i * 1, 'card_back_red');
      shadow.setDisplaySize(CARD_WIDTH, CARD_HEIGHT);
      shadow.setDepth(1 + i);
      shadow.setAlpha(0.6 + i * 0.15);
    }

    this.deckSprite = this.scene.add.image(this.deckX, this.deckY, 'card_back_red');
    this.deckSprite.setDisplaySize(CARD_WIDTH, CARD_HEIGHT);
    this.deckSprite.setDepth(4);
    this.deckSprite.setInteractive({ useHandCursor: true });

    this.deckSprite.on('pointerover', () => {
      this.deckSprite?.setTint(0xdddddd);
    });
    this.deckSprite.on('pointerout', () => {
      this.deckSprite?.clearTint();
    });
    this.deckSprite.on('pointerdown', () => {
      if (this.onDeckClick) this.onDeckClick();
    });

    // Deck count
    this.deckCountText = this.scene.add.text(this.deckX, this.deckY + CARD_HEIGHT / 2 + 12, '', {
      fontSize: '14px',
      color: COLORS.TEXT_LIGHT,
      fontFamily: 'Georgia, serif',
    }).setOrigin(0.5).setDepth(10);

    // Pozzetti (crossed, at separate position)
    const pozX = this.pozzettoX;
    const pozY = this.pozzettoY;

    this.pozzetto1 = this.scene.add.image(pozX, pozY, 'card_back_blue');
    this.pozzetto1.setDisplaySize(CARD_WIDTH, CARD_HEIGHT);
    this.pozzetto1.setDepth(2);

    this.pozzetto2 = this.scene.add.image(pozX + 8, pozY + 4, 'card_back_blue');
    this.pozzetto2.setDisplaySize(CARD_WIDTH, CARD_HEIGHT);
    this.pozzetto2.setAngle(90); // Crossed
    this.pozzetto2.setDepth(3);

    this.pozzettoLabel1 = this.scene.add.text(pozX - 5, pozY + CARD_HEIGHT / 2 + 12, 'Pozzetto', {
      fontSize: '11px',
      color: '#aaaaaa',
      fontFamily: 'Georgia, serif',
      fontStyle: 'italic',
    }).setOrigin(0.5).setDepth(10);
  }

  getDeckPosition(): { x: number; y: number } {
    return { x: this.deckX, y: this.deckY };
  }

  updateDeckCount(count: number): void {
    if (this.deckCountText) {
      this.deckCountText.setText(`${count} cards`);
    }
    if (this.deckSprite) {
      this.deckSprite.setAlpha(count > 0 ? 1 : 0.3);
      if (count === 0) this.deckSprite.disableInteractive();
      else this.deckSprite.setInteractive({ useHandCursor: true });
    }
  }

  updatePozzetti(pozzetti: [unknown[] | null, unknown[] | null]): void {
    if (this.pozzetto1) {
      this.pozzetto1.setVisible(pozzetti[0] !== null);
    }
    if (this.pozzetto2) {
      this.pozzetto2.setVisible(pozzetti[1] !== null);
    }
    if (this.pozzettoLabel1) {
      const remaining = (pozzetti[0] !== null ? 1 : 0) + (pozzetti[1] !== null ? 1 : 0);
      this.pozzettoLabel1.setText(remaining > 0 ? `Pozzetti: ${remaining}` : 'No pozzetti');
    }
  }

  destroy(): void {
    // Sprites are managed by the scene
  }
}
